module.exports = __webpack_public_path__ + "img/lock.e75d453e.png";